import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = { class: "modal2" }
const _hoisted_3 = { class: "modal-header flex-row flex-align-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-center flex-1 modal-header-title" }, "详情", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#333",
    d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body flex-row flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
          class: "modal-header-close"
        }, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("textarea", {
          rows: "2",
          class: "form-control",
          style: {"height":"400px"},
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.json) = $event))
        }, null, 512), [
          [_vModelText, _ctx.json]
        ])
      ])
    ])
  ]))
}